import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import PageBase from '../views/PageBase.vue';
import Settings from '../views/Settings/Settings.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: PageBase,

    children: [
      {
        path: '',
        pathMatch: 'full',
        name: 'home',
        component: Home,
      },
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
      }
    ]
    
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
